import React from 'react'
import { Control } from 'react-redux-form'
import { ReactBootstrapSlider } from 'react-bootstrap-slider'

class RangeSliderControl extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
      search: ''
    }
  }

  render() {
    const {
      model,
      createFromValue,
      children,
      newTicks,
      immediateChange,
      ...rest
    } = this.props
    const { isOpen } = this.state
    const parent = this
    //console.log("All props", this.props, rest)
    const changeEvent = immediateChange ? 'change' : 'slideStop'

    return (
      <Control.custom
        model={model}
        component={ReactBootstrapSlider}
        getValue={e => e}
        tooltip={true}
        tooltip_position="top"
        mapProps={{
          [changeEvent]: props => {
            const { onChange } = props

            return e => {
              //sentry had reported some issues where e was undefined
              const value = (e && e.target.value) || null
              //console.log("Calling onValueChange with", props, value, onChange);
              const newVal = value

              //console.log(newVal)
              onChange(newVal)
            }
          },
          value: props => {
            //console.log("props =", props);
            const { viewValue } = props
            //console.log("state =", parent.state);
            const values =
              Array.isArray(viewValue) && viewValue.length == 1
                ? [viewValue[0], viewValue[0]]
                : viewValue
            // console.log("values =", viewValue, values);
            const retVal = Array.isArray(values)
              ? [...values.map(v => parseInt(v))]
              : values
              ? values
              : [0, 0]

            // console.log("retVal = ", retVal)
            return retVal
          }
        }}
        {...rest}>
        {children}
      </Control.custom>
    )
  }
}

export default RangeSliderControl
